module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-panel"
  }, [_vm._v("No data available.")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89b68194"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/Empty.vue
// module id = 1230
// module chunks = 0